<form nz-form [formGroup]="justificativaForm" (ngSubmit)="salvarObservacoes()">
  <!-- Textarea section -->
  <nz-form-item>
    <nz-form-control [nzSm]="24" [nzXs]="24">
      <textarea nz-input rows="4" formControlName="textoJustificativa" placeholder="Digite sua justificativa aqui..." ></textarea>
    </nz-form-control>
  </nz-form-item>

  <!-- Action buttons -->
  <div class="row justify-content-end mt-4">
    <div class="col-sm-auto">
      <nz-form-item>
        <nz-form-control>
          <button nz-button nzType="default" type="button" (click)="fecharModal()">Cancelar</button>
          <button nz-button nzType="primary" type="submit" [disabled]="justificativaForm.invalid" class="ms-2">Adicionar</button>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
</form>
